import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-notification-view',
  templateUrl: './notification-view.component.html'
})
export class NotificationViewComponent implements OnInit {
  public icon: string;
  public content: string;

  constructor(
    public dialogRef: MatDialogRef<NotificationViewComponent>,
    private appConfig: AppConfig,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.content = this.data.content;

    switch (this.data.type) {
      case this.appConfig.NOTIFICATION.success:
        this.icon = 'fa-check-circle color-good';
        break;
      case this.appConfig.NOTIFICATION.error:
        this.icon = 'fa-times-circle color-bad';
        break;
      case this.appConfig.NOTIFICATION.fatalError:
        this.icon = 'fa-times-circle color-bad';
        this.content = 'Error';
        break;
      case this.appConfig.NOTIFICATION.alert:
        this.icon = 'fa-exclamation-circle color-alert';
        break;
      case this.appConfig.NOTIFICATION.info:
        this.icon = 'fa-info-circle color-info';
        break;
      default:
        this.icon = 'fa-info-circle color-none';
        break;
    }
  }
}
